// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type GeneralTlivChangesFragment = { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string, changeType: string, placeholder?: { __typename?: 'TakeoffLineItem', id: string } | null | undefined, location: { __typename?: 'Location', id: string, effectiveLocation: { __typename?: 'Location', id: string, name: string } }, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string } | null | undefined, identity: { __typename?: 'TakeoffLineItem', id: string, isProductMaterial: boolean, item: { __typename?: 'Item', id: string, name: string } } };

export const GeneralTlivChangesFragmentDoc = gql`
    fragment GeneralTlivChanges on TakeoffLineItemVersion {
  id
  displayName
  changeType
  placeholder {
    id
  }
  location {
    id
    effectiveLocation {
      id
      name
    }
  }
  materialVariant {
    id
    displayName
  }
  identity {
    id
    isProductMaterial
    item {
      id
      name
    }
  }
}
    `;